import React from 'react';
import { Select } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useListCompanies } from '@/hooks/v1/useListCompanies';
import type { CompanyDTO } from '@/components/ui/Inputs/types/response/company';
import { useApplicationContext } from '@/context/v1/Application/context';
import { COMPANY_FIELD } from './constants';
import { FieldFormItem } from './styles';

function buildOption({ id, name }: CompanyDTO) {
	const result = { label: name, value: id };

	return result;
}

export function Company(): JSX.Element {
	const { company, organization } = useApplicationContext();

	const { data: companies = [], isFetching } = useListCompanies({
		organization_id: organization?.id,
		company_id: company?.id
	});

	const options = companies.map(buildOption);

	return (
		<FieldFormItem name={COMPANY_FIELD} label={I18n.get('Industrial site')} labelCol={{ span: 24 }}>
			<Select disabled options={options} loading={isFetching} placeholder={I18n.get('Industrial site')} />
		</FieldFormItem>
	);
}
